import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getDirectoriesSourceToken;
export const getDirectories = ({
  token,
  limit,
  communityId,
  clientId = null,
  offset = 0,
  sourceToken = null
}) => {
  getDirectoriesSourceToken = updateSourceToken(
    getDirectoriesSourceToken,
    sourceToken
  );

  const requestUrl = `${TTP_API_URL}/organization/folder`;

  const fields = [
    "id",
    "name",
    "email",
    "phone",
    "abbreviation",
    "legalRepresentative"
  ];

  let filter = [];

  if (clientId) {
    filter.push({
      property: "id",
      value: clientId,
      operator: "eq"
    });
  }

  /*let filter = [
    {
      property: "id",
      value: communityId,
      operator: "eq"
    }
  ];*/

  //const sort = [{}];
  return axios
    .get(requestUrl, {
      cancelToken: getDirectoriesSourceToken && getDirectoriesSourceToken.token,
      params: {
        access_token: token,
        //access_token: "004cb879a81927c7739b1d8d1706adc6a789aa28",
        applyFolderRoleFilter: true,
        organization_id: communityId,
        //sort: JSON.stringify(sort),
        fields: fields.join(","),
        filter: JSON.stringify(filter),
        start: offset,
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/directory.js